import { useRef, ChangeEvent, KeyboardEvent, ClipboardEvent } from "react";

import styles from "./CodeInput.module.scss";

export interface InputCodeProps {
  code: string[];
  setCode: (code: string[]) => void;
}

export const CodeInput = ({ code, setCode }: InputCodeProps) => {
  const inputs = useRef<(HTMLInputElement | null)[]>([]);

  const processInput = (e: ChangeEvent<HTMLInputElement>, slot: number) => {
    const num = e.target.value;
    if (/[^0-9]/.test(num)) return;
    const newCode = [...code];
    newCode[slot] = num;

    setCode(newCode);
    if (slot !== length - 1) {
      inputs.current[slot + 1]?.focus();
    }
  };

  const onKeyUp = (e: KeyboardEvent<HTMLInputElement>, slot: number) => {
    if (e.key === "Backspace" && !code[slot] && slot !== 0) {
      const newCode = [...code];
      newCode[slot - 1] = "";
      setCode(newCode);
      inputs.current[slot - 1]?.focus();
    }
  };

  const onPaste = (e: ClipboardEvent) => {
    const pasted = e.clipboardData.getData("text/plain");
    const pastedCode = pasted.split("").slice(0, 6);

    if (pastedCode.length < 6) {
      return;
    }
    setCode(pastedCode);
  };

  return (
    <div className={styles.wrapper}>
      {code.map((num, idx) => {
        return (
          <input
            className={styles.input}
            key={idx}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={num}
            required
            // eslint-disable-next-line
            autoFocus={!code[0].length && idx === 0}
            onChange={(e) => processInput(e, idx)}
            onPaste={onPaste}
            onKeyUp={(e) => onKeyUp(e, idx)}
            ref={(ref) => inputs.current.push(ref)}
          />
        );
      })}
    </div>
  );
};
